import { ContentTypeFilterClause, ExplorableItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { GenericCard } from '../../../app/spaces/CardView/GenericCard';
import { ServerFilterClauses } from '../../helpers/ServerFilterClauses';
import { RemoteRefreshSchedules } from '../../resources/RemoteRefreshSchedules';
import { RemoteRefreshScheduleContentType } from '../ContentTypes';
import { LocallySortingScheduleResourceQuery } from '../../helpers/LocallySortingScheduleResourceQuery';

// TFS 829185
export const RemoteRefreshSchedulesDefinition: ExplorableItemDefinition = {
  itemType: 'remoteRefreshSchedule',
  pluralName: Messages.extractTasks,
  emptyStateMessage: Messages.extractTasksEmptyMessage,
  contentFilterKeys: [],
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['remoteRefreshSchedule']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    const resourceQuery = RemoteRefreshSchedules.all().withExtraParams(RemoteRefreshScheduleContentType.extraQueryParams);
    return new LocallySortingScheduleResourceQuery(resourceQuery);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
